module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Rpp Widget */

(function(fox) {

	var _options = {
			variants: {
				'default': '6x10' //also it can be array [10, 20, 30, 40, 50, ...]
			},
			tpl: [
				{
					container: {
						'default': 'select.fox-grid-rpp-container'
					},
					variant: {
						'default': 'option.fox-grid-rpp-variant[value=$[variant]]{$[variant]}'
					}
				}
			],
			handlers: [
				{
					changeRpp: [
						{target: {'default': '.fox-grid-rpp-container'}},
						{event: {'default': 'change'}}
					]
				}
			]
		};

	fox.registerWidget('Grid_Rpp', {

		//this.properties
		variants: null,

		//this.methods
		configure: function(options) {
			this['prepareOptions'](options, _options);
			this.callParent('configure', arguments);
		},

		init: function() {
			this.dl = this.options.dataLayer;
			this.prepareVariants();
			this.handleEvent(this.dl, 'loaded', fox.bind(this._applyDlChanges, this));
		},

		'domEventHandler': function(node, alias, e) {
			switch(alias) {
				case 'changeRpp':
					var value = node.dataset.variant || node.value;
					this.rpp = value;
					this.dl.setRpp(this.rpp).load();
					break;
				default:
					return callParent('domEventHandler', arguments);
			}
		},

		_applyDlChanges: function() {
			if (!this._indom) {
				this.render();
			} else {
				this.visualSwitchRpp(this.dl.getRpp());
			}
		},

		visualSwitchRpp: function(value) {
			this.select.value = value;
		},

		'rendering': function() {
			this.fragment = fox.Zen(this.options.tpl.container);
			this.select = this.fragment.firstChild;
			for (var i = 0, l = this.variants.length; i < l; i++) {
				this.select.appendChild(fox.Zen(this.options.tpl.variant, [{id: i, variant: this.variants[i]}]));
			}
		},

		prepareVariants: function() {
			if (fox.isArray(this.options.variants)) {
				return this.variants = this.options.variants;
			}
			var tmp = this.options.variants.split('x'),
				steps = parseInt(tmp[0]),
				modifier = parseInt(tmp[1]);
				this.variants = [];

			for(var i = 1; i <= steps; i++) {
				this.variants.push(modifier * i);
			}
			return this.variants;
		}

	});

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/grid/rpp.js
// module id = 204
// module chunks = 0